import _extends from "reshow-runtime/es/helpers/extends";
import _objectSpread from "reshow-runtime/es/helpers/objectSpread2";
import _objectWithoutProperties from "reshow-runtime/es/helpers/objectWithoutProperties";
import _classCallCheck from "reshow-runtime/es/helpers/classCallCheck";
import _createClass from "reshow-runtime/es/helpers/createClass";
import _assertThisInitialized from "reshow-runtime/es/helpers/assertThisInitialized";
import _possibleConstructorReturn from "reshow-runtime/es/helpers/possibleConstructorReturn";
import _getPrototypeOf from "reshow-runtime/es/helpers/getPrototypeOf";
import _inherits from "reshow-runtime/es/helpers/inherits";
import _defineProperty from "reshow-runtime/es/helpers/defineProperty";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { SemanticUI, Icon, reactStyle } from 'react-atomic-molecule';
import ChevronRight from 'ricon/ChevronRight';
import get from 'get-object-value';

var ArrowIcon = /*#__PURE__*/function (_Component) {
  _inherits(ArrowIcon, _Component);

  var _super = _createSuper(ArrowIcon);

  function ArrowIcon() {
    var _this;

    _classCallCheck(this, ArrowIcon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleEnter", function () {
      _this.setState({
        hoverStyle: {
          opacity: '.9'
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeave", function () {
      _this.setState({
        hoverStyle: {}
      });
    });

    return _this;
  }

  _createClass(ArrowIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          iconStyle = _this$props.iconStyle,
          onClick = _this$props.onClick,
          others = _objectWithoutProperties(_this$props, ["style", "iconStyle", "onClick"]);

      var hoverStyle = get(this.state, ['hoverStyle'], {});
      return /*#__PURE__*/React.createElement(SemanticUI, {
        style: _objectSpread({}, Styles.arrowContainer, {}, style, {}, hoverStyle),
        onMouseEnter: this.handleEnter,
        onMouseLeave: this.handleLeave,
        onClick: onClick
      }, /*#__PURE__*/React.createElement(Icon, _extends({}, others, {
        styles: reactStyle(_objectSpread({}, Styles.icon, {}, iconStyle), false, false)
      }), /*#__PURE__*/React.createElement(ChevronRight, {
        style: {
          cursor: 'pointer'
        }
      })));
    }
  }]);

  return ArrowIcon;
}(Component);

var CarouselList = /*#__PURE__*/function (_Component2) {
  _inherits(CarouselList, _Component2);

  var _super2 = _createSuper(CarouselList);

  function CarouselList() {
    _classCallCheck(this, CarouselList);

    return _super2.apply(this, arguments);
  }

  _createClass(CarouselList, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          carouselAttr = _this$props2.carouselAttr,
          innerContainer = _this$props2.innerContainer,
          style = _this$props2.style,
          onLeft = _this$props2.onLeft,
          onRight = _this$props2.onRight,
          others = _objectWithoutProperties(_this$props2, ["children", "carouselAttr", "innerContainer", "style", "onLeft", "onRight"]); // <!-- Child


      var thisChildren = children;

      if (carouselAttr) {
        thisChildren = React.Children.map(children, function (child) {
          return React.cloneElement(child, _objectSpread({}, carouselAttr));
        });
      }

      if (innerContainer) {
        thisChildren = React.cloneElement(innerContainer, {}, thisChildren);
      } // Child --> 


      var arrowLeft;
      var arrowRight;

      if (onLeft) {
        arrowLeft = /*#__PURE__*/React.createElement(ArrowIcon, {
          className: "backward",
          onClick: onLeft,
          iconStyle: Styles.leftIcon,
          style: Styles.arrowLeft
        });
      }

      if (onRight) {
        arrowRight = /*#__PURE__*/React.createElement(ArrowIcon, {
          className: "forward",
          onClick: onRight,
          iconStyle: Styles.rightIcon,
          style: Styles.arrowRight
        });
      }

      return /*#__PURE__*/React.createElement(SemanticUI, _extends({}, others, {
        style: _objectSpread({}, Styles.container, {}, style)
      }), thisChildren, arrowLeft, arrowRight);
    }
  }]);

  return CarouselList;
}(Component);

export default CarouselList;
var Styles = {
  container: {
    position: 'relative',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minHeight: 100
  },
  arrowContainer: {
    width: '15%',
    height: '100%',
    position: 'absolute',
    top: 0,
    backgroundRepeat: 'repeat-x',
    opacity: '.3',
    cursor: 'pointer'
  },
  arrowLeft: {
    left: 0,
    backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.3) 0, rgba(0,0,0,0.001) 100%)'
  },
  arrowRight: {
    right: 0,
    backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.001) 0, rgba(0,0,0,0.3) 100%)'
  },
  icon: {
    width: 50,
    height: 50,
    position: 'absolute',
    top: '50%',
    transform: ['translateY(-50%)'],
    fill: '#fff'
  },
  leftIcon: {
    transform: ['rotate(180deg) translateY(50%)']
  },
  rightIcon: {
    right: 0
  }
};